export default __webpack_public_path__ + "static/media/governance.8de78c3d.png";